import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import { useCheckout } from 'features/organizations/memberships/checkout/context';
import { CheckoutSteps } from 'features/organizations/memberships/checkout/types';

const SubmitSelectionButton = () => {
  const { cart, goToStep, checkoutSession } = useCheckout();
  const { t } = useTranslation(['checkout']);

  const goToSummary = () => {
    goToStep(CheckoutSteps.Summary);
  };

  if (!cart.isEmpty) {
    return (
      <div className="flex flex-col gap-2">
        {checkoutSession.checkoutError?.message && (
          <div className="text-sm font-normal text-error text-center pt-2">
            {checkoutSession.checkoutError.message}
          </div>
        )}
        <Button
          loading={checkoutSession.isLoadingCheckout}
          disabled={Boolean(
            checkoutSession.checkoutError || checkoutSession.isCheckoutDisabled
          )}
          variant="primaryDark"
          size="large"
          className="w-full"
          onClick={goToSummary}
        >
          {t('checkout:continueToCheckout')}
        </Button>
      </div>
    );
  }

  return null;
};

export default SubmitSelectionButton;
